'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SESSION_LENGTH_IN_MILLISECONDS = 1000 * 60 * 30; // 30 minutes

/* eslint-disable */
var refreshHamplitudeProperties = exports.refreshHamplitudeProperties = function refreshHamplitudeProperties(hamplitudeProperties, currentTime) {
  var last_event_id = hamplitudeProperties.last_event_id,
      last_sequence_number = hamplitudeProperties.last_sequence_number,
      session_id = hamplitudeProperties.session_id,
      last_timestamp_checked_against_session = hamplitudeProperties.last_timestamp_checked_against_session,
      rest = _objectWithoutProperties(hamplitudeProperties, ['last_event_id', 'last_sequence_number', 'session_id', 'last_timestamp_checked_against_session']);

  var refreshed = _extends({}, rest);
  var timeSinceSessionRefresh = currentTime - last_timestamp_checked_against_session;

  if (timeSinceSessionRefresh > SESSION_LENGTH_IN_MILLISECONDS) {
    refreshed.last_event_id = 0;
    refreshed.session_id = currentTime;
  } else {
    refreshed.session_id = session_id;
    refreshed.last_timestamp_checked_against_session = currentTime;
  }

  refreshed.last_event_id = last_event_id + 1;
  refreshed.last_sequence_number = last_sequence_number + 1;

  return refreshed;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.70/js/metaProperties/adapters.js
// module id = 396
// module chunks = 0